// URL field validator

export default ({ mandatory = false, customError = null }) => ({
  presence: mandatory && { message: customError },
  url: true
});


export const strictUrlValidator = ({ mandatory = false, customError = null }) => ({
  presence: mandatory && { message: customError },
  url: {
    schemes: ['http', 'https'],
    allowLocal: true // This allows local IP addresses
  }
});
